import View from "../framework/view";
import template from "../../pugc/signup";
import {SignupForm} from "./signup_form";

export class SignupView extends View {

    static classname = "signup-view";

    private form = new SignupForm(true);

    constructor() {
        super(SignupView.classname);
    }

    protected render0(): JQuery<HTMLElement> {
        const data = {
            form: this.form
        };

        const out = this.pug(template, data);
        return out;
    }

}
